import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import { FinalSelection } from "./FinalSelection";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { AlertPopUp } from "./AlertPopUp";
import Stepper from "@mui/material/Stepper";
import {
  getPizzaModifierCategories,
  getDefaultPizzaModifiers,
} from "../apis/RangerOnlineApi";
import styled from "@emotion/styled";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiTypography-body1": {
    [theme.breakpoints.up("sm")]: {
      fontSize: "14px !important",
      fontWeight: "100",
    },
    [theme.breakpoints.up("xs")]: {
      fontSize: "12px !important",
      fontWeight: "100",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "8px !important",
      fontWeight: "100",
    },
  },
  "& .MuiCheckbox-root": {
    padding: "2px",
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, name, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {name}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function PizzaModifierSelector(props) {
  const { product, sizeId, open, onClose, onSave } = props;
  const [modifierCategories, setModifierCategories] = useState([]);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleModifierChange = (e, id) => {
    const checked = e.target.checked;
    let modifiersCopy = [...modifierCategories];
    modifiersCopy
      .find((x) => x.modifierId == value)
      .modifiers.find((x) => x.pizzaModifierId == id).selected = checked;

    setModifierCategories(modifiersCopy);
  };

  const handleSaveChanges = () => {
    let modifiers = "";
    let subtitle = "";
    let modifiersPrice = 0;
    let selectedModifiers = [];

    modifierCategories.map((x) => {
      const modifiers = x.modifiers.filter((x) => x.selected === true);
      if (modifiers.length > 0) {
        selectedModifiers = [...selectedModifiers, ...modifiers];
      }
    });
    selectedModifiers
      .filter((x) => x.defaultTopping == 1 || x.selected)
      .map((x, index) => {
        if (x.defaultTopping == 0 && x.selected) {
          modifiers =
            modifiers +
            `\n* ADD ${x.pizzaModifierName} ${
              x.pizzaModifierPrice > 0
                ? `(${x.pizzaModifierPrice.toFixed(2)})`
                : ""
            }`;
          subtitle =
            subtitle + `${index > 0 ? ", " : ""}${x.pizzaModifierName}`;
          modifiersPrice += x.pizzaModifierPrice;
        } else if (x.defaultTopping == 1 && !x.selected) {
          modifiers = modifiers + `\n* NO ${x.pizzaModifierName}`;
          subtitle =
            subtitle + `${index > 0 ? ", " : ""}NO ${x.pizzaModifierName}`;
        } else {
          subtitle =
            subtitle + `${index > 0 ? ", " : ""}${x.pizzaModifierName}`;
        }
      });

    onSave({
      toppings: selectedModifiers,
      modifiers,
      subtitle,
      modifiersPrice,
    });
  };

  useEffect(() => {
    if (modifierCategories.length === 0) {
      getPizzaModifierCategories(product.productId, sizeId).then((x) => {
        if (x?.status) {
          console.log(x?.title);
        } else {
          setModifierCategories(x);
          setValue(x[0].modifierId);
        }
      });
    }
  }, []);

  return (
    <BootstrapDialog
      keepMounted={false}
      aria-labelledby="Pizza selection dialog"
      open={open}
      maxWidth="sm"
      fullWidth={true}
    >
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="Modifiers tabs"
            variant="scrollable"
            scrollButtons="auto"
          >
            {modifierCategories
              .filter((x) => x.modifiers.length > 0)
              .sort(function (a, b) {
                return a.modifierIndex - b.modifierIndex;
              })
              .map((category, index) => {
                return (
                  <Tab
                    key={category.modifierId}
                    value={category.modifierId}
                    label={category.modifierName}
                    sx={{ fontSize: "12px", minWidth: "50px" }}
                  />
                );
              })}
          </Tabs>
        </Box>
        {modifierCategories
          .filter((x) => x.modifiers.length > 0)
          .sort(function (a, b) {
            return a.modifierIndex - b.modifierIndex;
          })
          .map((category, index) => {
            return (
              <TabPanel
                key={category.modifierId}
                value={value}
                index={category.modifierId}
              >
                {category.modifiers.map((x, index) => {
                  let label = x.pizzaModifierName;
                  if (x.defaultTopping == 1) {
                    label = label;
                  } else {
                    label = `${label}  ${
                      x.pizzaModifierPrice > 0
                        ? ` $(${x.pizzaModifierPrice.toFixed(2)})`
                        : ""
                    }`;
                  }
                  return (
                    <Box
                      key={x.pizzaModifierId}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <FormGroup key={index} sx={{ alignSelf: "center" }}>
                        <FormControlLabel
                          key={index}
                          control={
                            <Checkbox
                              checked={x.selected}
                              disabled={x.noSubstitute == 1}
                              onClick={(e) =>
                                handleModifierChange(e, x.pizzaModifierId)
                              }
                            />
                          }
                          label={label}
                        />
                      </FormGroup>
                    </Box>
                  );
                })}
              </TabPanel>
            );
          })}
      </Box>
      <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
        <Button color="error" autoFocus onClick={onClose}>
          Cancel
        </Button>
        <Button autoFocus onClick={handleSaveChanges}>
          Add to cart
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}
